export const formatPrice = (price: string | number): string => {
    const floatPrice = parseFloat(price.toString())
    const fixedPrice = (Math.round(floatPrice * 100) / 100).toFixed(2)
    return `€ ${fixedPrice.replace('.', ',')}`
}